import { useSignal } from '@funtech-int/rival-react';
import { usePopupsManager } from '@funtech-int/web-toolkit';

import { isPaymentWidget } from '@/shared/lib/popups';

export const useIsPaymentManagerOpened = () => {
    const popupsManager = usePopupsManager();
    const popups = useSignal(popupsManager.popups);

    return popups.some(isPaymentWidget);
};
